import request from '@/utils/request'

/**
 * 简历关键词API
 * @type {string}
 */
const basePath = "/api/resume/keyword";

/**
 * 修改关键词集合
 * @param params
 */
export function saveResumeKeywordList(params) {
    return request({
        url: `${basePath}/${params.resumeId}`,
        method: 'put',
        data: params
    })
}

/**
 * 根据标签id获取标签树
 * @param params
 */
export function getKeywordListByParentId(labelId) {
    return request({
        url: `/api/label/${labelId}`,
        method: 'get'
    })
}

